import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.chartData, this.options)
    //this.renderChart(this.chartData, {maintainAspectRatio:false, responsive:false})
  }
}



// WEBPACK FOOTER //
// ./src/lib/LineChart.js